import React from "react";
import { useTranslation } from "react-i18next";

const ProductUnavailable = React.memo(
    () => {
        const { t } = useTranslation();
        return (<div className='flex justify-content-center mb-2'>
            <span className="font-bold text-xs border-round-lg py-1 px-3 bg-gray-100 text-gray-600">
                {t(`Unavailable`)}
            </span>
        </div>);
    }
)
export default ProductUnavailable;